import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateFaqTabData,faqTabData }) => {
    const [sidebarLayoutType, setSidebarLayoutType] = useState(faqTabData.sidebar_layout_type);
    const [activeAccordionIcon, setAccordionIconSection] = useState(faqTabData.accordion_icon_type);
    const [isOpenFirstQuestionByDefault, setOpenFirstQuestionByDefault] = useState(Number(faqTabData.is_open_first_question_by_default));
    const [isMultipleActiveQuestion, setMultipleActiveQuestion] = useState(Number(faqTabData.is_multiple_active_question));
    const [isOpenSearchBar, setOpenSearchBar] = useState(Number(faqTabData.is_open_search_bar));

    // Handle Sidebar Layout Type change
    const handleSidebarLayoutTypeChange = (event) => {
        setSidebarLayoutType(event.target.value);
        updateFaqTabData("sidebar_layout_type", event.target.value);
    };

    // Handle Accordion Icon change
    const handleAccordionIconInputChange = (event) => {
        setAccordionIconSection(event.target.value);
        updateFaqTabData("accordion_icon_type", event.target.value);
    };

    //Handlers Open First Question By Default Change
    const handleOpenFirstQuestionByDefaultChange = (e) => {
        const checked = e.target.checked;
        setOpenFirstQuestionByDefault(checked);
        updateFaqTabData("is_open_first_question_by_default", checked); 
    };


    //Handlers Multiple Active Question Change
    const handleMultipleActiveQuestionChange = (e) => {
        const checked = e.target.checked;
        setMultipleActiveQuestion(checked);
        updateFaqTabData("is_multiple_active_question", checked); 
    };

    //Handlers Open Search Bar Change
    const handleOpenSearchBarChange = (e) => {
        const checked = e.target.checked;
        setOpenSearchBar(checked);
        updateFaqTabData("is_open_search_bar", checked); 
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Layout</span>
            <div className="side-baar-box-header">
                <div className="left-cnater-right-button mb-0">
                    <label className="card-radio-btn">
                        <input type="radio" name="sidebar_layout_type" className="card-input-element d-none" value="Accordion" onChange={handleSidebarLayoutTypeChange} checked={sidebarLayoutType === "Accordion"} />
                        <div className="card card-body">
                            <div className="content_sub">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M6 15a2 2 0 0 1 2-2h48a2 2 0 0 1 2 2v10H6V15Zm5 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm43.83-.82a.644.644 0 0 1 0 .874l-1.506 1.584a1.12 1.12 0 0 1-1.648 0l-1.505-1.584a.644.644 0 0 1 0-.873.56.56 0 0 1 .824 0l1.093 1.147a.56.56 0 0 0 .824 0l1.093-1.147a.56.56 0 0 1 .824 0ZM6 26h52v12H6V26Zm5 6a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm43.83-.82a.644.644 0 0 1 0 .874l-1.506 1.584a1.12 1.12 0 0 1-1.648 0l-1.505-1.584a.644.644 0 0 1 0-.873.56.56 0 0 1 .824 0l1.093 1.147a.56.56 0 0 0 .824 0l1.093-1.147a.56.56 0 0 1 .824 0ZM6 39h52v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V39Zm5 6a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm43.83-.82a.644.644 0 0 1 0 .874l-1.506 1.584a1.12 1.12 0 0 1-1.648 0l-1.505-1.584a.644.644 0 0 1 0-.873.56.56 0 0 1 .824 0l1.093 1.147a.56.56 0 0 0 .824 0l1.093-1.147a.56.56 0 0 1 .824 0Z" clip-rule="evenodd"></path></svg>
                            </div>
                            <div className="content_sub">Accordion</div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="sidebar_layout_type" className="card-input-element d-none" value="List" onChange={handleSidebarLayoutTypeChange} checked={sidebarLayoutType === "List"} />
                        <div className="card card-body">
                            <div className="content_sub">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M6 11a2 2 0 0 1 2-2h48a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8Zm5 2a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h33a1 1 0 1 0 0-2H12ZM6 28a2 2 0 0 1 2-2h48a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8Zm5 2a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h33a1 1 0 1 0 0-2H12ZM6 45a2 2 0 0 1 2-2h48a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8Zm5 2a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h33a1 1 0 1 0 0-2H12Z" clip-rule="evenodd"></path></svg>
                            </div>
                            <div className="content_sub">List</div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="sidebar_layout_type" className="card-input-element d-none" value="Multicolumn" onChange={handleSidebarLayoutTypeChange} checked={sidebarLayoutType === "Multicolumn"} />
                        <div className="card card-body">
                            <div className="content_sub">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M2 19a2 2 0 0 1 2-2h23a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8Zm4 2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2H7Zm28-5a2 2 0 0 1 2-2h23a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H37a2 2 0 0 1-2-2v-8Zm4 2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2H40ZM2 36a2 2 0 0 1 2-2h23a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8Zm4 2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2H7Zm28-5a2 2 0 0 1 2-2h23a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H37a2 2 0 0 1-2-2v-8Zm4 2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2H40Z" clip-rule="evenodd"></path></svg>
                            </div>
                            <div className="content_sub">Multicolumn</div>
                        </div>
                    </label>
                </div>
            </div>
            
            {sidebarLayoutType === "Accordion" && (
                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <p>Accordion Icon</p>
                        <div className="left-cnater-right-button">
                            <label className="card-radio-btn">
                                <input type="radio" name="accordion_icon_type" className="card-input-element d-none" value="Plus" onChange={handleAccordionIconInputChange} checked={activeAccordionIcon === "Plus"} />
                                <div className="card card-body">
                                    <div className="content_sub">Plus</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="accordion_icon_type" className="card-input-element d-none" value="Arrow" onChange={handleAccordionIconInputChange} checked={activeAccordionIcon === "Arrow"} />
                                <div className="card card-body">
                                    <div className="content_sub">Arrow</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            )}

            <div className="side-baar-box-header">
                {sidebarLayoutType === "Accordion" && (
                <>
                    <div className="box-header-row ">
                        <span>Open First Question by Default</span>
                        <div className="form-group">
                            <input id="open_is_open_first_question_by_default" className="chkbx-toggle" type="checkbox" checked={isOpenFirstQuestionByDefault} onChange={handleOpenFirstQuestionByDefaultChange} />
                            <label for="open_is_open_first_question_by_default"></label>
                        </div>
                    </div>
                    <div className="box-header-row ">
                        <span>Multiple Active Questions</span>
                        <div className="form-group">
                            <input id="open_is_multiple_active_questions" className="chkbx-toggle" type="checkbox" checked={isMultipleActiveQuestion} onChange={handleMultipleActiveQuestionChange} />
                            <label for="open_is_multiple_active_questions"></label>
                        </div>
                    </div>
                </>
                )}
                <div className="box-header-row ">
                    <span>Show Search Bar</span>
                    <div className="form-group">
                        <input id="open_is_search_bar" className="chkbx-toggle" type="checkbox" checked={isOpenSearchBar} onChange={handleOpenSearchBarChange} />
                        <label for="open_is_search_bar"></label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;